import { useTranslation } from 'react-i18next';
import { IoLogoWhatsapp } from 'react-icons/io';
import MaskField from '../../../../components/MaskField';
import { allCountriesCodeLabels } from '../../../../utils/countries';
import { phoneValidation as validatePhone } from '../../../../utils/validations';
import {
  Container,
  IconWrapper,
  Title,
  Description,
  PhoneFieldsContainer,
  PhoneInputsRow,
  SelectCountryField,
  PhoneField,
  PhoneHelperText,
} from './styles';

export default function ContactCard({ phone, onPhoneChange }) {
  const { t } = useTranslation();
  const hasPhoneError = phone.phoneValidation?.phoneInvalidError;

  const handleCountryCodeChange = (countryCode) => {
    onPhoneChange({
      ...phone,
      countryCode,
      phoneValidation: validatePhone(phone.number, countryCode),
    });
  };

  const handlePhoneChange = (event) => {
    const number = event.target.value;

    onPhoneChange({
      ...phone,
      number,
      phoneValidation: validatePhone(number, phone.countryCode),
    });
  };

  return (
    <Container>
      <IconWrapper>
        <IoLogoWhatsapp />
      </IconWrapper>
      <Title>{t('settings.steps.contact.heading')}</Title>
      <Description>{t('settings.steps.contact.description')}</Description>
      <PhoneFieldsContainer>
        <PhoneInputsRow>
          <SelectCountryField
            selected={phone.countryCode}
            onSelect={handleCountryCodeChange}
            allCountriesWithCustomLabel={allCountriesCodeLabels}
            searchable
            searchPlaceholder=" "
            showSecondarySelectedLabel={false}
            showSecondaryOptionLabel={false}
          />
          <PhoneField>
            <MaskField
              fullWidth
              inputMode="numeric"
              type="text"
              id="phone"
              name="phone"
              placeholder={t('settings.steps.contact.phonePlaceholder')}
              value={phone.number}
              onChange={handlePhoneChange}
              variant="outlined"
              autoComplete="phone"
              margin="none"
              mask="99999999999999999999"
              error={hasPhoneError}
              fontSizeLabel={14}
              fontSizeLegend={11}
            />
            {hasPhoneError && (
              <PhoneHelperText error id="phone-error">
                {t('errors.phone-invalid')}
              </PhoneHelperText>
            )}
          </PhoneField>
        </PhoneInputsRow>
      </PhoneFieldsContainer>
    </Container>
  );
}
